import * as angular from 'angular';
import { config } from 'angular/utils/config';

class LngLocationDetailsViewCtrl implements ng.IController {
    public storageLocation: StorageLocationDto;
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public loggedInUser: LoginResult;
    public stageConfig = config;

    constructor(private $window) {}

    $onInit() {}

    public goBack(): void {
        this.$window.history.back();
    }
}

angular.module('app').component('pkpLngLocationDetailsView', {
    controller: LngLocationDetailsViewCtrl,
    template: require('app/lng-location/lng-location-details-view.component.html'),
    bindings: {
        form: '=',
        loggedInUser: '<',
        storageLocationId: '<',
        storageLocation: '=',
        isEditMode: '<?',
        isCreateMode: '<?'
    }
});
